import baseAos from 'aos';
import 'aos/dist/aos.css';
import { isMobile } from 'detect-mobile-device';

/**
 * example
 * 直接在Dom节点中填入 '{...aos.XXX()}' 即可补充aos样式
 * <div className="rule-group-2" {...aos.FADE_UP()} >
 *
 */

const $aos = baseAos;

// /**
//  * 初始化aos
//  */
// $aos.init({
//   disable: false,
//   offset: isMobile() ? -9999 : 120
// });

/**
 * 再次初始化
 */
const reInit = () => {
  $aos.init({
    disable: false,
    offset: isMobile() ? -9999 : 120
  });
};

const refreshHard = () => {
  $aos.refresh();
};

// 声明缓存变量
const caches = {};

/**
 * 创建Aos对象, 进行同类aos缓存
 * @param data
 * @returns {*}
 */
const createAosObject = data => {
  if (!caches[data]) {
    // noinspection JSUnresolvedFunction
    caches[data] = Object.freeze({ 'data-aos': data });
  }
  return caches[data];
};

// aos 官网提供滚动样式库
const animateObj = {
  FADE_IN: 'fade-in',
  FADE_UP: 'fade-up',
  FADE_DOWN: 'fade-down',
  FADE_LEFT: 'fade-left',
  FADE_RIGHT: 'fade-right',
  FADE_UP_LEFT: 'fade-up-left',
  FADE_UP_RIGHT: 'fade-up-right',
  FADE_DOWN_LEFT: 'fade-down-left',
  FADE_DOWN_RIGHT: 'fade-down-right',
  ZOOM_IN: 'zoom-in',
  ZOOM_IN_UP: 'zoom-in-up',
  ZOOM_IN_DOWN: 'zoom-in-down',
  ZOOM_IN_LEFT: 'zoom-in-left',
  ZOOM_IN_RIGHT: 'zoom-in-right',
  ZOOM_OUT: 'zoom-out',
  ZOOM_OUT_UP: 'zoom-out-up',
  ZOOM_OUT_DOWN: 'zoom-out-down',
  ZOOM_OUT_LEFT: 'zoom-out-left',
  ZOOM_OUT_RIGHT: 'zoom-out-right',
  FLIP_UP: 'flip-up',
  FLIP_DOWN: 'flip-down',
  FLIP_LEFT: 'flip-left',
  FLIP_RIGHT: 'flip-right'
};

/**
 * 输出的aos动画类型
 * @type {{ZOOM_IN_LEFT: (function(): *), FADE_UP: (function(): *), ZOOM_IN_DOWN: (function(): *), ZOOM_IN_RIGHT: (function(): *), FLIP_DOWN: (function(): *), FLIP_LEFT: (function(): *), FLIP_UP: (function(): *), ZOOM_OUT_UP: (function(): *), FADE_DOWN: (function(): *), ZOOM_OUT_RIGHT: (function(): *), ZOOM_IN: (function(): *), ZOOM_OUT: (function(): *), FADE_RIGHT: (function(): *), ZOOM_OUT_DOWN: (function(): *), FADE_LEFT: (function(): *), ZOOM_OUT_LEFT: (function(): *), FLIP_RIGHT: (function(): *), ZOOM_IN_UP: (function(): *)}}
 */
const aos = {
  reInit: () => reInit(),
  refreshHard: () => refreshHard(),
  ZOOM_IN: () => createAosObject(animateObj.ZOOM_IN),
  ZOOM_IN_UP: () => createAosObject(animateObj.ZOOM_IN_UP),
  ZOOM_IN_DOWN: () => createAosObject(animateObj.ZOOM_IN_DOWN),
  ZOOM_IN_LEFT: () => createAosObject(animateObj.ZOOM_IN_LEFT),
  ZOOM_IN_RIGHT: () => createAosObject(animateObj.ZOOM_IN_RIGHT),
  ZOOM_OUT: () => createAosObject(animateObj.ZOOM_OUT),
  ZOOM_OUT_UP: () => createAosObject(animateObj.ZOOM_OUT_UP),
  ZOOM_OUT_DOWN: () => createAosObject(animateObj.ZOOM_OUT_DOWN),
  ZOOM_OUT_LEFT: () => createAosObject(animateObj.ZOOM_OUT_LEFT),
  ZOOM_OUT_RIGHT: () => createAosObject(animateObj.ZOOM_OUT_RIGHT),
  FADE_IN: () => createAosObject(animateObj.FADE_IN),
  FADE_UP: () => createAosObject(animateObj.FADE_UP),
  FADE_DOWN: () => createAosObject(animateObj.FADE_DOWN),
  FADE_LEFT: () => createAosObject(animateObj.FADE_LEFT),
  FADE_RIGHT: () => createAosObject(animateObj.FADE_RIGHT),
  FLIP_UP: () => createAosObject(animateObj.FADE_UP),
  FLIP_DOWN: () => createAosObject(animateObj.FADE_UP),
  FLIP_LEFT: () => createAosObject(animateObj.FADE_UP),
  FLIP_RIGHT: () => createAosObject(animateObj.FADE_UP)
};

export default aos;
